import { defineMessages } from 'react-intl';

export default defineMessages({
    reasonForRemovingName: {
        id: 'ml.policychange.MLReasonComponent.Reason for removing name',
        defaultMessage: 'Reason for removing {name}?'
    },
    reasonNotListed: {
        id: 'ml.policychange.MLReasonComponent.Reason Not Listed as Driver',
        defaultMessage: 'Reason Not Listed as Driver'
    }
});
